import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { getter } from "@progress/kendo-react-common";

import { Toolbar, Button } from "@progress/kendo-react-buttons";
import {
    Grid,
    GridColumn,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";
import { GroupDescriptor } from '@progress/kendo-data-query';

import { useGetReportsQuery } from '../../store/sunbright-api';

export interface OpenSummaryGridProps {
    fromDate: string;
    toDate: string;
    returnLabel: string;
    onReturn?: any;
}

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialGroup: GroupDescriptor[] = [{ field: 'region' }];

const OpenSummaryGrid = ({
    fromDate,
    toDate,
    returnLabel,
    onReturn,
}: OpenSummaryGridProps) => {
    const { data: report, error: reportError, isLoading: reportLoading } = useGetReportsQuery("opened?from=" + fromDate + "&to=" + toDate);

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
   }, [report]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);

        setSelectedUID(Object.keys(newState)[0]);
    };

    return (
        <React.Fragment>
            <div>
                <Toolbar>
                    <Button
                        className="sds-buttoninbar"
                        icon="undo"
                        onClick={(e) => onReturn()}
                    >
                        {returnLabel}
                    </Button>
                    <div style={{ fontSize: "large", fontWeight: "bold", paddingLeft: "64px" }}>
                        Open Exam Summary
                    </div>
                </Toolbar>

                {reportError ? (<>Not Authorized</>) : reportLoading ? <Loader size="large" type="converging-spinner" /> : report ?
                    (
                        <Grid
                        style={{ height: gridHeight }}
                        className="eventSummaryGrid"
                        data={report.map((item: any) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)]
                        }))}

                        autoProcessData={true}
                        groupable={true}
                        defaultGroup={initialGroup}

                        resizable={true}
                        size={"small"}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            mode: "single",
                        }}
                        onSelectionChange={handleSelectionChange}
                  >
                        <GridColumn field="region" title="Region" width="0px"/>
                        <GridColumn field="opened" title="Opened" format="{0:MMM d yyyy}" width="95px" />
                        <GridColumn field="petOwner" title="Pet (Owner)" width="212px" />
                        <GridColumn field="species" title="Species" width="68px" />
                        <GridColumn field="agencyGroup" title="Agency Group" />
                        <GridColumn field="caseWorker" title="Case Worker" width="182px" />
                        <GridColumn field="veterinarian" title="Veterinarian" width="164px"/>
                        <GridColumn field="id" title="ID" width="160px" />
                    </Grid>) : null}
                </div>
        </React.Fragment>
    );
}
export default OpenSummaryGrid;